<template>
	<div>
		<b-modal ref="modalError"
			hide-footer
			title="Erreur">
			<lottie_error />
			<p class="my-4">{{ text_error }}</p>
		</b-modal>
		<div class="row">
			<div class="col-12 col-lg-6 mt-4">
				<form>
					<div class="form-group" v-if="hasTitleField">
						<label class="title_label keyText"
							for="title">{{ $t("Title.title") }}</label>
						<span class="modificationLabel"> {{ this.modificationTitle }} </span> <input type="text"
						class="form-control no-border"
						@change="setModificationTitleLabel"
						@input="setModificationTitleLabel"
						id="title"
						v-model="inputValue">
					</div>
				</form>
			</div>
		</div>
		<div class="row">
			<div class="col-12 col-lg-6 mt-4">
				<form>
					<div class="form-group" v-if="hasSecondaryTitleField">
						<label class="title_label keyText"
							for="secondaryTitle">{{ $t("Title.secondary_title") }}</label>
						<span class="modificationLabel"> {{ this.modificationSecondaryTitle }} </span>
						<input type="text"
							class="form-control no-border"
							id="secondaryTitle"
							@change="setModificationSecondaryTitleLabel"
							@input="setModificationSecondaryTitleLabel"
							v-model="inputSecondaryValue">
					</div>
				</form>
			</div>
		</div>

		<div class="form-group">
			<label><input type="checkbox" name="mute" v-model="hasMusicEnable"
				@change="setModified" /> {{ $t("Button.enable_music") }}</label>
			<span class="modificationLabel"> {{ this.modification_mute }} </span><br />
			<label>Volume : {{ music_volume }}%<br /><input :disabled="!hasMusicEnable" @change="setModified" type="range" id="music_volume" name="music_volume"
				min="10" max="100" step="10" v-model="music_volume"></label>
		</div>

		<div class="row">
			<b-col md="auto" style="padding-left: 0;">
				<ValidStep :value="inputValue"
					:secondaryValue="inputSecondaryValue"
					:music_enabled="hasMusicEnable"
					:music_volume="music_volume"
					:id="id"
					:disabled="!modified"
				/>
			</b-col>
			<b-col md="auto" style="padding-left: 0;">
				<div class="mt-4">
					<a
						class="btn btn-reinitialization"
						href="#"
						@click="reset"
						:class="[isCompleted ? '' : 'disabled']"
					>{{ $t("Button.reset") }}</a>
				</div>
			</b-col>
			<b-col md="auto" style="padding-left: 0;">
				<div class="mt-4">
					<a href="#"
						class="btn btn-cancel"
						@click="reset_modified"
						:class="[modified ? '' : 'disabled']">{{ $t("Button.modifications") }}</a>
				</div>
			</b-col>
		</div>
	</div>
</template>

<script>
import ValidStep from "../ui/buttons/ValideStepLogo";
import axios from "axios";
import {EventBus} from "../../event/event-bus";
import lottie_error from "@/components/ui/lottie_error";

const BASE_URL = process.env.VUE_APP_BASE_URL;

export default {
	name: "Title",
	components: {lottie_error, ValidStep},
	props: {
		id: Number,
		stepName: String,
		title: String,
		secondaryTitle: String,
		hasTitleField: Boolean,
		hasSecondaryTitleField: Boolean,
		hasCarouselVideos: Boolean,
		hasVoiceOver: Boolean,
		projectId: Number,
		imageId: Number,
		groupId: String,
		renderId: String,
		stepIndex: Number,
		isCompleted: Boolean,
		isVisible: Boolean,
		created_at: String,
		updated_at: String,
	},
	data() {
		return {
			value: "",
			value2: "",
			value_init: true,
			value2_init: true,
			hasMusicEnable: true,
			music_volume: 100,
			text_error: "",
			modificationTitle: "",
			modificationSecondaryTitle: "",
			modification_mute: "",
			modified: false,
		};
	},
	computed: {
		inputValue: {
			get() {
				return this.value;
			},
			set(v) {
				this.value = v;
			},
		},
		inputSecondaryValue: {
			get() {
				return this.value2;
			},
			set(v) {
				this.value2 = v;
			},
		},
	},
	created() {
		let $this = this;
		EventBus.$on("setModificationLabel", label => {
			$this.modificationTitle = label;
		});
		EventBus.$on("setModificationSecondaryTitleLabel", label => {
			$this.modificationSecondaryTitle = label;
		});
		EventBus.$on("setModified", bool => {
			if (bool) {
			}
			else {
				this.reset_modified();
			}
		});
	},
	beforeMount() {
		this.getDatas();
	},
	methods: {
		getDatas() {
			let $this = this;
			if (this.id === undefined || this.id === null) {
				axios.get(BASE_URL + "/public/api/stepTitles/project/" + this.$route.params.id, {
					headers: {
						"Authorization": sessionStorage.getItem("auth"),
					},
				})
				.then(function (response) {
					let data = response.data.data;

					$this.hasMusicEnable = data.hasMusicEnable;
					$this.music_volume = data.music_volume;

					if (data.title === null || data.secondaryTitle === undefined) {
						$this.inputValue = "";
					}
					else {
						$this.inputValue = data.title;
					}
					if (data.secondaryTitle === null || data.secondaryTitle === undefined) {
						$this.inputSecondaryValue = "";
					}
					else {
						$this.inputSecondaryValue = data.secondaryTitle;
					}
					$this.isCompleted = data.isCompleted;

					if (data.isCompleted) {
						EventBus.$emit("setStepTitleComplete", $this.id);
					}
					else {
						EventBus.$emit("setStepTitleNotComplete", $this.id);
					}

				}).catch(error => {
					this.text_error = this.$root.$t("Errors.message_project") + error;
					this.$refs.modalError.show();
				});
			}
			else {
				axios.get(BASE_URL + "/public/api/stepTitles/" + this.id,
					{
						headers: {
							"Authorization": sessionStorage.getItem("auth"),
						},
					})
				.then(function (response) {
					let data = response.data.data;

					$this.hasMusicEnable = data.hasMusicEnable;
					$this.music_volume = data.music_volume;

					if (data.title === null || data.secondaryTitle === undefined) {
						$this.inputValue = "";
					}
					else {
						$this.inputValue = data.title;
					}
					if (data.secondaryTitle === null || data.secondaryTitle === undefined) {
						$this.inputSecondaryValue = "";
					}
					else {
						$this.inputSecondaryValue = data.secondaryTitle;
					}

					$this.isCompleted = data.isCompleted;

					if (data.isCompleted) {
						EventBus.$emit("setStepTitleComplete", $this.id);
					}
					else {
						EventBus.$emit("setStepTitleNotComplete", $this.id);
					}
				}).catch(error => {
					this.text_error = this.$root.$t("Errors.message_project") + error;
					this.$refs.modalError.show();
				});
			}
		},
		reset() {
			// this.$refs.loaderModal.show();

			axios.get(BASE_URL + "/public/api/stepTitles/" + this.id + "/reset",
				{
					headers: {
						"Authorization": sessionStorage.getItem("auth"),
					},
				})
			.then(response => {
				// this.$refs.loaderModal.hide();
				this.getDatas();
			}).catch(error => {
				// this.$refs.loaderModal.hide();
				this.text_error = this.$root.$t("Errors.message_project") + error;
				this.$refs.modalError.show();
			});
		},
		setModificationTitleLabel() {
			this.modificationTitle = this.$root.$t("Button.editing");
			this.modified = true;
			EventBus.$emit("lock_steps", {id: this.id, type: "App\\StepTitle"});
		},
		setModificationSecondaryTitleLabel() {
			this.modificationSecondaryTitle = this.$root.$t("Button.editing");
			this.modified = true;
			EventBus.$emit("lock_steps", {id: this.id, type: "App\\StepTitle"});
		},
		setModified() {
			this.modified = true;
			this.modification_mute = this.$root.$t("Button.editing");
			EventBus.$emit("lock_steps", {id: this.id, type: "App\\StepTitle"});
		},
		reset_modified() {
			this.getDatas();
			EventBus.$emit("unlock_steps", {id: this.id, type: "App\\StepTitle"});
			this.modified = false;
			this.modification_mute = "";
			this.modificationTitle = "";
			this.modificationSecondaryTitle = "";
		},
	},
};
</script>

<style scoped>
input {
	border-radius: 0;
	border-top: none;
	border-left: none;
	border-right: none;
	border-bottom: #8AA0B2 solid 1px;
}

.modificationLabel {
	font-size: 14px;
	color: var(--color-modification);
}

.btn-cancel {
	background-color: var(--color-modification);
	border-color: var(--color-modification);
	color: var(--text-modification);
}

.btn-reinitialization {
	background-color: var(--color-cancel);
	border-color: var(--color-cancel);
	color: var(--text-cancel);
}

label {
	color: #144B5E;
}
</style>
